import $ from 'jquery';
import 'velocity-animate';
import 'velocity-animate/velocity.ui';

let mediumTiming = 400;
let fastTiming = 200;

export default function () {
  $.Velocity.RegisterUI('player-lightbox-show-desktop', {
    defaultDuration: fastTiming,
    calls          : [
      [{ translateX: 0 }, 1, { display: 'block' }],
    ],
  });

  $.Velocity.RegisterUI('player-lightbox-show', {
    defaultDuration: fastTiming,
    calls          : [
      [{ translateX: '100%', height: '395px' }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('player-lightbox-hide', {
    defaultDuration: fastTiming,
    calls          : [
      [{ translateX: '-100%' }, 1, { display: 'none' }],
    ],
  });

  $.Velocity.RegisterUI('top-bar-intro', {
    defaultDuration: mediumTiming,
    calls          : [
      [{ opacity: 1, translateY: 0 }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('top-bar-exit', {
    defaultDuration: mediumTiming,
    calls          : [
      [{ opacity: 0, translateY: '-2em' }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('top-bar-exit-search', {
    defaultDuration: fastTiming,
    calls          : [
      [{ opacity: 0, translateY: '-2.75em' }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('footer-intro', {
    defaultDuration: mediumTiming,
    calls          : [
      [{ opacity: 1, translateY: 0 }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('footer-exit', {
    defaultDuration: mediumTiming,
    calls          : [
      [{ opacity: 0, translateY: '2rem' }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('trailers-slices-intro', {
    defaultDuration: mediumTiming,
    calls          : [
      [{ opacity: 1, 'margin-left': 0 }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('trailers-slices-enter', {
    defaultDuration: fastTiming,
    calls          : [
      [{ opacity: 1, translateY: 0 }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('trailers-slices-exit', {
    defaultDuration: mediumTiming,
    calls          : [
      [{ opacity: 0, translateY: '9%' }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('trailers-slices-active-enter', {
    defaultDuration: fastTiming,
    calls          : [
      [{ opacity: 1, translateY: 0 }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('trailers-slices-active-exit', {
    defaultDuration: fastTiming,
    calls          : [
      [{ opacity: 0, translateY: '9%' }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('homepage-video-enter', {
    defaultDuration: mediumTiming,
    calls          : [
      [{ opacity: 0.33, scale: 1.85 }, 1, {}],
    ],
  });

  $.Velocity.RegisterUI('homepage-video-exit', {
    defaultDuration: mediumTiming,
    calls          : [
      [{ opacity: 1, scale: 1 }, 1, {}],
    ],
  });
}
